import * as React from "react";
import { Typography } from "@material-ui/core";

interface IProps {
    text: string,
}

export const Fender: React.SFC<IProps> = (props) => {
  return (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        padding: '8px'
    }}>
      <Typography variant="caption" align="center" style={{fontStyle: 'italic'}}>{props.text}</Typography>
    </div>
  )
};



// WEBPACK FOOTER //
// ./src/shared/Fender/Fender.tsx